
import { Component, Vue, Prop } from 'vue-property-decorator';

import { stepInfoType } from "@/types/Application";
import PageBase from "@/components/steps/PageBase.vue";
import GetHelpForPdf from "./helpPages/GetHelpForPDF.vue";
import FormList from "./components/FormList.vue"
import RequiredDocument from "./components/RequiredDocument.vue"
import ReminderNotes from "./components/ReminderNotes.vue"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import "@/store/modules/common";
import { locationsInfoType } from '@/types/Common';
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const commonState = namespace("Common");

@Component({
    components:{
        PageBase,
        GetHelpForPdf,
        FormList,
        RequiredDocument,
        ReminderNotes
    }
})    
export default class ReviewAndSave extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @commonState.State
    public locationsInfo!: locationsInfoType[];

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;    

    currentStep =0;
    currentPage =0;
    error = ""
    hasPOselected =  false;

    showGetHelpForPDF = false;    
    applicantLocation = {} as locationsInfoType;

    mounted(){

        this.hasPOselected =  false;
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        let progress = this.$store.state.Application.steps[this.currentStep].pages[this.currentPage].progress
        if(progress==0) progress=50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
           
        let location = this.$store.state.Application.applicationLocation
        if(!location) location = this.$store.state.Common.userLocation

        this.applicantLocation = this.locationsInfo.filter(loc => {if (loc.name == location) return true})[0]

        const includesOrderActivities = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity.includes('applyForOrder');
        
        if(includesOrderActivities && this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.selectedForms?.includes('protectionOrder'))  
            this.hasPOselected =  true;
    } 

    public downloaded(){
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, false);
    }
    
    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage()
    }

    public navigateToGuide(){
        Vue.filter('scrollToLocation')("pdf-guide");
    }

}
